import { handleApi } from './common';

const MF_ORDERS_API_CONSTANTS = {
  fetchFundsInfo: "api/mf/funddata",
  triggerInvestment: "/api/invest"
}

export const fetchfundsInfo = async (Api, investmentType, isins, token) => {
  const fundOrderData = await Api.get(`${MF_ORDERS_API_CONSTANTS.fetchFundsInfo}/${investmentType}?type=isin&isins=${isins}`, {}, {}, token);
  return handleApi(fundOrderData);
};

export const trigger_investment = async (Api, body, token) => {
  const response = await Api.post(
    MF_ORDERS_API_CONSTANTS.triggerInvestment,
    body,
    {},
    token
  );
  return handleApi(response);
};
